//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { AttendanceMakeupCreditIssue } from './Enums';

export class AttendanceMakeupCreditIssueDisplayItem extends ItemBase {
    AttendanceID: string | null = null;
    MakeupCreditIssue: AttendanceMakeupCreditIssue = AttendanceMakeupCreditIssue.AtMax;

    constructor(initializer?: Partial<AttendanceMakeupCreditIssueDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AttendanceMakeupCreditIssueDisplayItem";
}
